export default function tsToLocaleTimeString(timestamp) {
	return timestamp
		?.toDate()
		?.toLocaleTimeString(navigator.language, { hour12: false, hour: "numeric", minute: "numeric" });
}
